import { render, staticRenderFns } from "./PnlAttributes.vue?vue&type=template&id=07daad3a&scoped=true"
import script from "./PnlAttributes.vue?vue&type=script&lang=js"
export * from "./PnlAttributes.vue?vue&type=script&lang=js"
import style0 from "./PnlAttributes.vue?vue&type=style&index=0&id=07daad3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07daad3a",
  null
  
)

export default component.exports